module.exports = __webpack_public_path__ + "static/media/sunglasses.286c8675.svg";